export default "__VITE_ASSET__93696223__"